var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1C2.67925 1 1 2.74947 1 4.90789C1 6.65026 1.65625 10.7855 8.116 14.9658C8.23171 15.0399 8.36455 15.0791 8.5 15.0791C8.63545 15.0791 8.76829 15.0399 8.884 14.9658C15.3438 10.7855 16 6.65026 16 4.90789C16 2.74947 14.3207 1 12.25 1C10.1793 1 8.5 3.36842 8.5 3.36842C8.5 3.36842 6.82075 1 4.75 1Z",
    stroke: "#3CB4E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.53228ea7405f7482bbf3d5f6d736e021.svg";
export { ForwardRef as ReactComponent };